import React, { useEffect, useState } from "react";
import SuccessCheckIcon from "../../../../assets/images/check-success-green-icon.svg";
import "./document-list-view.scss";

import { ReactComponent as UploadIcon } from "../../../../assets/images/cloud-upload-yellow.svg";
import { ReactComponent as AlertInfoIcon } from "../../../../assets/images/info-icon.svg";
import { DeleteFilled } from "@ant-design/icons";

// ANT Design Imports
import { Card, Typography, Space, Button, Alert ,Modal} from "antd";
import { getThumbnailImagePath } from "../../../../util/documentThumbUtility";
import Preview from "../../../../common/preview/preview";
const { Text } = Typography;

const DocumentListView = ({
  documentData,
  onDelete,
  openUploadDrawer,
  ocrParsedDataDocuments,
}) => {
  const [missingDocsMessage, setMissingDocsMessage] = useState("");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState({ file: null, fileName: "" });

  useEffect(() => {
    if (!ocrParsedDataDocuments?.length) return;

    const missingDocs = ocrParsedDataDocuments
      .filter((doc) => doc.status === false)
      .map((doc) => {
        return (
          doc.errors?.[0]?.message ||
          doc.docType
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())
        );
      });

    if (missingDocs.length > 0) {
      setMissingDocsMessage(
        // `Missing ${missingDocs.join(
        `${missingDocs.join(
          ", "
        )}. You can either upload them again or skip for now.`
      );
    } else {
      setMissingDocsMessage("");
    }
  }, [ocrParsedDataDocuments]);


  const handlePreviewClick = ({ file, fileName }) => {
    setPreviewFile({ file, fileName });
    setIsPreviewModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsPreviewModalOpen(false);
    setPreviewFile(null);
  };

  return (
    <>
      <div className="document-list-view-wrapper">
        {/* {documentData.length === 0 && ( */}
        {missingDocsMessage && (
          <Space className="document-alert-box" direction="vertical" size={8}>
            <Alert
              message={missingDocsMessage}
              type="warning"
              icon={<AlertInfoIcon />}
              showIcon
              className="custom-alert"
            />
            <Button
              type="text"
              className="upload-doc-button"
              icon={<UploadIcon />}
              onClick={openUploadDrawer}
            >
              Upload Document
            </Button>
          </Space>
        )}
        {/* )} */}
        {documentData?.map((docItem, index) => {
          const file = docItem?.file;
          const fileName = file?.name || `Document ${index + 1}`;
          const fileSizeMB = file?.size
            ? (file.size / (1024 * 1024)).toFixed(1) + "MB"
            : "-";
          const fileURL = file ? URL.createObjectURL(file) : "";
          return (
            <div className="document-list-container-item">
              <Text className="doc-title">{fileName}</Text>
              <Card
                className="document-card"
                style={{
                  height: "100%",
                  padding: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer"
                }}
                // onClick={() =>
                //   handlePreviewClick({ file: file, fileName: file?.name || `Document ${index + 1}` })
                // }
                  onClick={(e) => {
                  const isButtonClick =
                    ["button", "svg"].includes(e.target.tagName?.toLowerCase()) ||
                    e.target.getAttribute("role") === "button" ||
                    e.target.closest("button, [role='button'], .delete-icon");

                    if (isButtonClick) return;

                    handlePreviewClick({
                      file: file,
                      fileName: file?.name || `Document ${index + 1}`,
                    });
                  }}
              >
                <div className="absolute-block">
                  <DeleteFilled
                    className="delete-icon"
                    // onClick={() => onDelete?.(index)}
                    // onClick={() => onDelete?.(fileName)}
                    onClick={(e) => {
                      e.stopPropagation(); 
                      onDelete?.(fileName);
                    }}

                  />
                  <Text className="doc-inner-title">{index + 1} Document</Text>
                </div>

                <div 
                  className="file-preview-wrapper"   
               
                  style={{ cursor: "pointer" }}
                >
                  {file?.type?.startsWith("image/") ? (
                    <img
                      src={fileURL}
                      alt={fileName}
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                  ) : (
                    <img
                      src={getThumbnailImagePath(file?.name)}
                      alt="File Preview"
                      style={{
                        maxWidth: "60px",
                        maxHeight: "60px",
                        objectFit: "contain",
                        margin: "auto",
                      }}
                    />
                  )}
                </div>
              </Card>
              <Space align="center" size={8}>
                <img
                  src={SuccessCheckIcon}
                  alt="success-check-icon"
                  width={16}
                  height={16}
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Text className="size-text">File size {fileSizeMB}</Text>
              </Space>
            </div>
          );
        })}
      </div>
        <Modal
          title="Preview"
          open={isPreviewModalOpen}
          onCancel={handleModalCancel}
          centered
          footer={null}
          className="big-modal"
          style={{ width: "90%" }}
        >
          {previewFile?.file && (
            <Preview
              uploadedfile={URL.createObjectURL(previewFile.file)}
              uploadedFileName={previewFile.fileName}
            />
          )}
        </Modal>
    </>
  );
};

export default DocumentListView;
